import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import Bole from '@haptik/helpers/build/esm/bole';
import HelperUtils from '@haptik/helpers/build/esm/platformUtils';
import { getAllPlatforms } from '@src/api/business';

import { BASE_URL } from '@src/const';

import {
  SENTRY_REPORTING_URL,
  SENTRY_ENVIRONMENTS_ALLOWED,
} from '@src/constants/MogamboConstants';

import App from './app';
import BotStore from './store';
import { captureException, getUserInfo } from './api';
import './styles/main.scss';

const baseURL = `${BASE_URL.replace('/mogambo_api', '')}`;

HelperUtils.getFeatureToggles(baseURL)
  .then((response) => {
    if (!response.success) {
      captureException(response.error);
      return;
    }

    BotStore.setFeaturesData(response.data);
  })
  .catch((error) => {
    captureException(error);
  });

getAllPlatforms().then((platforms) => {
  if (platforms.body) {
    const allPlatforms = platforms.body.map((platform) => ({
      title: platform.title,
      value: platform.id,
    }));
    BotStore.setPlatformsData(allPlatforms);
  }
});

getUserInfo()
  .then((json) => {
    if (json.response) {
      BotStore.setUserInfo(json.response);
      BotStore.setMixPanel(json.response);
      BotStore.emitChange();
    }

    if (SENTRY_ENVIRONMENTS_ALLOWED.includes(process.env.ENV_NAME)) {
      Bole.setContext({
        user: json.response,
        sentryDSN: SENTRY_REPORTING_URL,
        sentryEnvironment: process.env.ENV_NAME,
      });
    }

    ReactDOM.render(<App />, document.getElementById('mogambo_app'));
  })
  .catch(captureException);
